import { Box, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";

function AmountLargeBox(props) {
  const { amount, onClick = () => {}, error = false } = props;
  return (
    <Box
      onClick={onClick}
      sx={{
        width: "100%",
        minHeight: 80,
        px: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "20px",
        border: (theme) =>
          `1px solid ${
            error ? theme.palette.error.main : theme.palette.primary.main
          }`,
      }}
    >
      <Typography variant="h1" color="primary.main">
        {toToman(amount)}
      </Typography>
      <Typography variant="subtitle1" color="primary.main">
        تومان
      </Typography>
    </Box>
  );
}

export default AmountLargeBox;
